var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-text-field',{attrs:{"rules":_vm.rules,"placeholder":_vm.placeholder,"label":_vm.with_label ? _vm.placeholder : undefined,"disabled":_vm.disabled,"hide-details":"auto","data-test-id":"zip-code-input"},on:{"keydown":_vm.auto_correct},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }